import {Component, Input} from '@angular/core';
import {WetterblitzSchlagzeile} from '../../../../../../../model/vorhersagen/rbb-document';

@Component({
  selector: 'app-schlagzeile-wetterblitz-bericht',
  templateUrl: './schlagzeile-wetterblitz-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class SchlagzeileWetterblitzBerichtComponent {

  @Input()
  wetterblitzSchlagzeile?: WetterblitzSchlagzeile;

}
